import BaseService from "./base.service";
const service = new BaseService("/clients")
export default service;